<script setup>
import config from '@/common/config'
import Pagination from '@/common/pagination'
import { down, get, openWin } from '@/common/util'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive,ref } from 'vue'
const props=defineProps(['id','ispage','parentheight','tblheight','type']),metaStore=useMetaStore(),meta=reactive({search:{page:1,size:40},data:{features:[]},tblheight:400,gslayer:{}}),card=ref(null)
,genParam=(stidx,size,output='application/json')=>{
  const wpm={
    "service": "WFS",
    "version": "1.0.0",
    "request": "GetFeature",
    "outputFormat": output,
    "typeName": meta.gslayer.nm,
    "maxFeatures": size,
    "startIndex": stidx
  }
  if (!_.isEmpty(meta.search.txt)) {
    const searchText = meta.search.txt;
    const fieldName = meta.selfield;
    const isNumeric = !isNaN(searchText) && !isNaN(parseFloat(searchText));
    if (isNumeric) {
      wpm.Filter = `<Filter>
          <PropertyIsEqualTo>
            <PropertyName>${fieldName}</PropertyName>
            <Literal>${searchText}</Literal>
          </PropertyIsEqualTo>
        </Filter>`;
    } else {
      if(searchText=='[]'){
        wpm.Filter = `<Filter>
            <PropertyIsEqualTo>
                <PropertyName>${fieldName}</PropertyName>
                <Literal>${searchText}</Literal>
            </PropertyIsEqualTo>
        </Filter>`;
      }else{
        wpm.Filter = `<Filter>
            <PropertyIsLike wildCard="*" singleChar="?" escape="!">
              <PropertyName>${fieldName}</PropertyName>
              <Literal>*${searchText}*</Literal>
            </PropertyIsLike>
          </Filter>`;
      }
    }
  }
  return wpm
},openDataDetail=async()=>{
  openWin(config.frontRoot+'member/datadetail/'+props.id+'/'+props.type)
},downFile=async()=>{
  let wpm=genParam(0,9999999,'csv')
  down({url:'/wfs?'+new URLSearchParams(wpm).toString(),fn:meta.item.nm+'.csv',method:'get'})
},search=async()=>{
  let wpm=genParam(0,1)
  metaStore.blockLoading()
  meta.data=await get('wfs',()=>{},wpm)
  meta.totalPages=1
  meta.pageCount=5
  if(meta.data.features.length){
    meta.heads=meta.data.features[0]
    meta.heads=_.keys(meta.heads.properties)
    if(!meta.selfield)meta.selfield=meta.heads[0]
    let pag=new Pagination(meta.data.totalFeatures)
    pag.setCurrentPage(meta.search.page)
    pag.setPageSize(meta.search.size)
    wpm=genParam(pag.getStartIndex(),meta.search.size)
    meta.data=await get('wfs',()=>{},wpm)
    if(props.type=='sv'){
      const dummyidx=meta.data.features.findIndex(feature=>feature.properties.xpos==null)
      if(dummyidx>-1)meta.data.features.splice(dummyidx,1)
    }
    pag.setTotalItems(meta.data.totalFeatures)
    meta.totalPages=pag.getTotalPages()
  }
  metaStore.blockLoading(false)
  if(!_.isEmpty(props.tblheight))meta.tblheight=parseFloat(props.tblheight.toString())
  else meta.tblheight=window.innerHeight-250
}
metaStore.blockLoading()
get('rest/authed/member/'+props.type+'/'+props.id,async res=>{
  metaStore.blockLoading(false)
  meta.item=res.data
  meta.gslayer.nm=props.type=='layer'||props.type=='objdetect'?meta.item.gslayernm:meta.item.gspointnm
  search()
})
</script>
<template>
<v-card ref="card" :flat="props.ispage!==true" v-if="meta.item" class="ma-2">
  <v-card-title>
    <v-defaults-provider :defaults="{VSelect:{hideDetails:true,variant:'outlined',density:'compact'},VTextField:{hideDetails:true,variant:'outlined',density:'compact'}}">
      <v-row class="ma-1">
        <v-col>{{ meta.item.nm }}</v-col>
        <v-col v-if="props.ispage===true"><v-select :items="meta.heads" v-model="meta.selfield"/></v-col>
        <v-col v-if="props.ispage===true"><v-text-field clearable v-model="meta.search.txt"/></v-col>
        <v-col v-if="props.ispage===true" cols="1"><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="meta.search.page=1;search()"/></v-col>
        <v-col class="text-right">
          <v-btn v-if="props.ispage!==true" :text="$t('viewinanewwindow')" @click="openDataDetail"/>
          <v-btn v-if="props.ispage===true" class="ms-2" :text="$t('downloadingdata')" @click="downFile"/>
        </v-col>
      </v-row>
    </v-defaults-provider>
  </v-card-title>
  <v-card-text class="overflow-y">
    <v-table v-if="meta.data.features.length" fixed-header class="datadetailtbl" :height="meta.tblheight">
      <thead>
        <tr>
          <th v-for="head in meta.heads" class="text-no-wrap text-center">{{ head }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="feature in meta.data.features">
          <td v-for="head in meta.heads" class="text-no-wrap">{{ feature.properties[head] }}</td>
        </tr>
      </tbody>
    </v-table>
  </v-card-text>
  <v-card-actions>
    <v-pagination class="ma-auto" v-if="meta.data.features.length" :length="meta.totalPages" :total-visible="meta.pageCount" v-model="meta.search.page" @update:model-value="search"/>
  </v-card-actions>
</v-card>
</template>
<style>
.datadetailtbl{border: 1px solid #797979;}
.datadetailtbl th{height: 30px !important;text-align: center !important;background-color: #f2f2f2 !important;}
.datadetailtbl th,.datadetailtbl td{border: 1px solid #e0e0e0;}
</style>
